<template>
  <div>
    <!-- {{ model }} -->
    <label class="error" v-for="item in errors" :key="item">
      {{ item }}
    </label>
  </div>
</template>

<script>
import { filter, forEach } from 'lodash';
import { translations } from '@/mixins';

export default {
  name: 'FormError',
  props: ['model', 'dirty', 'label', 'sameAs'],
  mixins: [translations],
  computed: {
    errors() {
      const validationErrors = filter(this.model.$params, (item, index) => {
        // item can be null when validating array, so we need to check it here is item available
        if (item?.type === 'requiredIf' && !this.model['required'] && this.dirty) {
          return item;
        }

        // validating array items
        if (index === '$each') {
          forEach(this.model.$each.$iter, (item, index) => {
            console.log('$iter', item, index)
          });
        }
        if (!this.model[index] && this.dirty) {
          return item;
        }
      });

      const messages = validationErrors.map((item) => {
        console.log(item);
        switch (item.type) {
          case 'required': 
          case 'requiredIf': 
            return this.translations.forms.errors.required.replace('{field}', `"${this.label}"`);
          case 'minLength':
            return this.translations.forms.errors.minLength.replace('{count}', item.min);
          case 'maxLength':
            return this.translations.forms.errors.maxLength.replace('{count}', item.max);
          case 'minValue':
            return `Polje ${this.label} mora biti veće od 0.`;
          case 'notNegative':
            return `Polje ${this.label} ne može biti negativno.`;
          case 'maxValue':
            return `Polje ${this.label} ne može biti veće od ${item.max}.`;
          case 'integer':
          case 'numeric':
          case 'decimal':
            return this.translations.forms.errors.integer.replace('{field}', `"${this.label}"`);
          case 'email':
            return this.translations.forms.errors.email.replace('{field}', `"${this.label}"`);
          case 'url':
            return this.translations.forms.errors.url.replace('{field}', `"${this.label}"`);
          case 'sameAs':
            return this.translations.forms.errors.sameAs.replace('{field}', `"${this.label}"`).replace('{field2}', `"${this.sameAs}"`);
          case 'greaterThan':
            return this.translations.forms.errors.greaterThanSecond;
          default:
            console.log(item);
            return this.translations.forms.errors.default;
        }
      });
      return messages;
    },
  },
}
</script>

<style lang="scss" scoped>
label.error {
  width: 100%;
}
</style>
